// DS: PO63
import React, { useContext, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import Button from '../Button';
import Flex from '@wix/da-ds/pkg/Flex';
import { ReverseTheme } from '@wix/da-react-context/pkg/ThemeContext';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SocialLoginModuleLoader from '../SocialLogin/redux/ModuleLoader';
import SocialButtonApple from '../SocialLogin/SocialButtonApple';
import SocialButtonGoogle from '../SocialLogin/SocialButtonGoogle';
import SocialButtonFacebook from '../SocialLogin/SocialButtonFacebook';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './SisuFunnelBanner.scss';
function isPinterest() {
    if (typeof document === 'undefined') {
        return false;
    }
    // Pinterest has a number of TLDs, so we gonna assume
    // any domain in the form "pinterest.[tld]" belongs to pinterest.
    return /^https?:\/\/(www\.)?pinterest\./.test(document.referrer);
}
const SisuFunnelBanner = ({ visible, restrictLoggedOut, pageType })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const onJoinClick = useCallback(()=>{
        restrictLoggedOut({
            restrictedActionName: ReferralType.SISU_FUNNEL_BANNER
        });
    }, [
        restrictLoggedOut
    ]);
    const hasSocialButtons = !isMobile;
    return /*#__PURE__*/ React.createElement(Flex, {
        className: classnames(s['root'], visible && s['root-visible']),
        alignItems: "center",
        justifyContent: "center",
        direction: isMobile ? 'column' : 'row'
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['text']
    }, isPinterest() ? t('sisuFunnel.text.pinterest') : t('sisuFunnel.text')), /*#__PURE__*/ React.createElement(ReverseTheme, {
        className: s['buttons']
    }, /*#__PURE__*/ React.createElement(Button, {
        href: Url.loginLink(),
        view: "b14-1",
        className: classnames(s['button'], s['login']),
        fullWidth: false,
        biData: BiData({
            evid: 245,
            referral_info: ReferralType.SISU_FUNNEL_BANNER
        })
    }, t('sisuFunnel.login')), /*#__PURE__*/ React.createElement(Button, {
        onClick: onJoinClick,
        view: "b1-1",
        className: s['button'],
        fullWidth: false,
        biData: BiData({
            evid: 241,
            referral_info: ReferralType.SISU_FUNNEL_BANNER
        })
    }, t('sisuFunnel.join')), hasSocialButtons && /*#__PURE__*/ React.createElement(SocialLoginModuleLoader, null, /*#__PURE__*/ React.createElement("div", {
        className: s['social-separator']
    }, t('sisuFunnel.separator')), /*#__PURE__*/ React.createElement(SocialButtonGoogle, {
        className: s['social-button'],
        redirectToSisu: true,
        view: "icon",
        lazyload: true
    }), /*#__PURE__*/ React.createElement(SocialButtonApple, {
        className: s['social-button'],
        view: "icon",
        redirectToSisu: true
    }, t('sisuFunnel.button.continue.apple')), /*#__PURE__*/ React.createElement(SocialButtonFacebook, {
        className: s['social-button'],
        view: "icon",
        redirectToSisu: true
    }, t('sisuFunnel.button.continue.facebook')))));
};
SisuFunnelBanner.displayName = 'SisuFunnelBanner';
export default SisuFunnelBanner;

//# sourceMappingURL=SisuFunnelBanner.js.map